import styled from "styled-components";

import { Modal } from "components/Modal";

export const ConfirmationModalContainer = styled(Modal)`
  padding: 30px;

  .modal-dialog {
    max-width: 512px;

    .modal-content {
      padding: 30px 50px;

      .modal-body {
        padding: 0;
        margin-top: 0;
        text-align: center;

        .title {
          font-weight: 500;
          font-size: 20px;
          text-align: center;
          color: ${({ theme }) => theme.card.font.tertiary};
          padding: 0.8em 1em 0;
          word-wrap: break-word;
        }

        .description {
          margin: 14px 0px;
          font-weight: 400;
          font-size: 15px;
          text-align: center;
          color: ${({ theme }) => theme.card.font.tertiary};
        }

        .actions {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 1.25em auto 0;

          .btn-cancel {
            background: ${({ theme }) => theme.button.bg.primary};
            border: 0;
            color: ${({ theme }) => theme.button.font.primary};
            padding: 10px 0;
            width: 208.5px;
            height: 40px;
            font-weight: 500;
            font-size: 14px;
            margin-top: 0.5rem;
            margin-left: 17px;

            &.btn-cancel-approval {
              border: 1px solid ${({ theme }) => theme.button.bg.primary};
              background: transparent;
              color: ${({ theme }) => theme.button.bg.primary};
            }

            /* Paired with .btn-confirm-deploy: the two swap this modal's
               default colours so the deliberate action is the primary one and
               backing out keeps the alarm colour. */
            &.btn-cancel-deploy {
              background: ${({ theme }) => theme.constants.COLOR_RED};
              color: ${({ theme }) => theme.button.font.primary};
              transition: background 0.15s ease;

              /* No darker-red token exists to pair with COLOR_RED. */
              &:hover:not(:disabled) {
                background: #e02e2e;
              }
            }
          }

          .btn-confirm {
            background: #ff3f3f;
            width: 208.5px;
            padding: 10px 0;
            font-weight: 500;
            font-size: 14px;
            height: 40px;
            border: medium;
            margin: 0.5rem 0 0 0rem;

            &.walkthrough-btn {
              background-color: #048af5;
              padding: 10px 24px;
              width: auto;
              text-wrap: nowrap;
            }

            &.btn-confirm-billing {
              background: ${({ theme }) => theme.button.bg.secondary};
              color: ${({ theme }) => theme.button.bg.primary};
            }

            &.btn-confirm-approval {
              background: ${({ theme }) => theme.button.bg.primary};
            }

            &.btn-confirm-deploy {
              background: ${({ theme }) => theme.button.bg.primary};
              transition: background 0.15s ease;

              &:hover:not(:disabled) {
                background: ${({ theme }) => theme.button.hover.color};
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;

      .modal-content .modal-body .actions {
        flex-direction: column-reverse;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .btn-cancel,
        .btn-confirm {
          margin: 0px;
          padding: 20px;
          display: flex;
          align-items: center;
          width: 100%;
          text-align: center;
          justify-content: center;
        }
      }

      .btn-confirm {
        margin-left: 0;
      }
    }
  }

  @media screen and (max-width: 500px) {
    .modal-dialog .modal-content {
      padding: 20px;
    }
  }
`;
